import { render, staticRenderFns } from "./SubvendorSelect.vue?vue&type=template&id=6b75143c"
import script from "./SubvendorSelect.vue?vue&type=script&lang=js"
export * from "./SubvendorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports